module.exports = __webpack_public_path__ + "img/Logo_Interify_black.b241cab8.svg";